import {
  Box,
  Center,
  CloseButton,
  Image,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  useDisclosure,
} from '@chakra-ui/react';
// import LazyLoadImageComponent from '@moms/Ui/LazyLoadImageComponent';
import { useEffect, useState } from 'react';
const SciImage = ({ src, ...props }) => {
  const [isHovered, setIsHovered] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure();
  useEffect(() => {
    if (!isOpen) {
      setIsHovered(false);
    }
  }, [isOpen]);
  return (
    <Box
      pos="relative"
      maxW={280}
      //   display={{ base: 'block', md: 'none' }}
      onClick={() => setIsHovered(true)}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      {...props}
    >
      <Center
        w="100%"
        height="100%"
        pos="absolute"
        display={isHovered ? 'flex' : 'none'}
        top={0}
        left={0}
        right={0}
        bottom={0}
        bg="linear-gradient(0deg, rgba(0, 0, 0, 0.20) 0%, rgba(0, 0, 0, 0.20) 100%)"
        onClick={onOpen}
      >
        <Center
          bg="#fff"
          width="40px"
          height="40px"
          rounded="full"
          padding=".5rem"
          onClick={onOpen}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M14 4L20 4M20 4L20 10M20 4L14 10M10 14L4 20M4 20L4 14M4 20L10 20"
              stroke="#010102"
              strokeWidth="2"
              strokeLinecap="square"
            />
          </svg>
        </Center>
      </Center>
      <Image src={src} />
      {/* <Button onClick={onOpen}>Open Modal</Button> */}

      <Modal
        isOpen={isOpen}
        onClose={onClose}
        closeOnOverlayClick={false}
        size="full"
      >
        <ModalOverlay />
        <ModalContent>
          <ModalBody
            alignItems="center"
            justifyContent="center"
            display="flex"
            w="100%"
            height="100%"
          >
            <Box w="100%" height="100%">
              <Center
                width="80vw"
                height="80vh"
                pos="relative"
                mx="auto"
                bg="#010102"
                my="auto"
              >
                <CloseButton
                  onClick={onClose}
                  top="-.5rem"
                  pos="absolute"
                  right="-.5rem"
                  bg="#fff"
                  padding=".5rem"
                  fontSize="1rem"
                  width="auto"
                  height="auto"
                  rounded="full"
                  boxShadow="0px 8px 8px 0px rgba(0, 0, 0, 0.16)"
                />
                <Image
                  src={src}
                  height={{ base: 'auto', md: '100%' }}
                  width={{ base: 'auto', md: '100%' }}
                />
              </Center>
            </Box>
          </ModalBody>
        </ModalContent>
      </Modal>
    </Box>
  );
};
export default SciImage;
